import { Reducer } from 'redux';
import { Action } from 'Store/types';

export enum ActionTypes {
  SET_OWNER_DATA = '@ownerData/SET',
}
export type OwnerData = any;

export type OwnerDataReducer = Reducer<OwnerData, Action<ActionTypes>>;
